import { render, staticRenderFns } from "./InsUserGallery.vue?vue&type=template&id=dae60168&scoped=true&"
import script from "./InsUserGallery.vue?vue&type=script&lang=ts&"
export * from "./InsUserGallery.vue?vue&type=script&lang=ts&"
import style0 from "./InsUserGallery.vue?vue&type=style&index=0&id=dae60168&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae60168",
  null
  
)

export default component.exports